import React, { ChangeEvent, useEffect, useState } from 'react';
import { makeStyles } from 'tss-react/mui';
import { observer } from 'mobx-react';
import { Grid } from '@mui/material';
import {
  AvatarEmpty,
  BasicAccordion,
  BasicModal,
  BasicTable,
  Button,
  CardComponent,
  cellStyles4,
  Columns,
  Filter,
  NoComplianceAssurances,
  PageTitleAndSubTitle,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import ticketManagementConstants from '../../core-utils/messages/TicketManagementConstants';
import Snackbar from '../../_components/atoms/Snackbar';
import { AlertColor as MuiColor } from '@mui/material/Alert';
import { pageScrollDown } from '../SummaryPage';
import NewTicketModal from '../../_components/organisms/NewTicketModal';
import { useStores } from '../../stores';
import axios from 'axios';
import properties from '../../core-utils/properties';
import { UserAccessConstants } from '../../core-utils/helper-utils/userAccess';
import {
  CircularLoader,
  patientAccessTheme,
} from '@HomaHealth/ui-component-library';
import {
  formatFileSize,
  formatTicketData,
  getAvatarComponent,
} from '../../core-utils/helper-utils/TaskBoardHelper';
import moment from 'moment';
import TicketDetailsWindow from '../../_components/organisms/TicketDetailsWindow';
import { scrollBarStyles } from '../../core-utils/messages/CommonConstants';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import TicketFilterModal, {
  FilterData,
  FilterOption,
} from '../../_components/molecules/TicketFilterModal';
import SupportCenter from '@HomaHealth/ui-component-library/lib/_AIQ-components/atoms/Icons/SupportCenter';

const TicketManagementPage = observer(() => {
  //Styles
  const useStyles = makeStyles()({
    root: {
      display: 'flex',
      flexDirection: 'column',
      padding: '40px 0px 66px 0px',
      width: '100%',
      height: '100%',
    },
    topRightButtons: {
      display: 'flex',
      gap: '20px',
    },
    accordion: {
      gap: '20px',
      width: '100%',
      marginTop: '30px',
    },
  });
  const { classes } = useStyles();

  //Stores
  const loginPageStore = useStores().loginPageStore;

  //Constants
  const userId = loginPageStore.userId;
  const tableColumns: Columns[] = [
    {
      name: 'id',
      align: 'left',
      cellStyles: cellStyles4,
      width: '0px',
      showThisColumn: true,
    },
    {
      name: 'Ticket #',
      align: 'left',
      cellStyles: cellStyles4,
      width: '100px',
      showThisColumn: true,
    },
    {
      name: 'Topic',
      align: 'left',
      cellStyles: cellStyles4,
      width: '350px',
      showThisColumn: true,
    },
    {
      name: 'Platform',
      align: 'left',
      cellStyles: cellStyles4,
      width: '250px',
      showThisColumn: true,
    },
    {
      name: 'Type',
      align: 'left',
      cellStyles: cellStyles4,
      width: '200px',
      showThisColumn: true,
    },
    {
      name: 'Status',
      align: 'left',
      cellStyles: cellStyles4,
      width: '150px',
      showThisColumn: true,
    },
    {
      name: 'Due Date',
      align: 'left',
      cellStyles: cellStyles4,
      width: '200px',
      showThisColumn: true,
    },
    {
      name: 'Assignee',
      align: 'left',
      cellStyles: cellStyles4,
      width: '100px',
      showThisColumn: true,
    },
  ];
  const role = loginPageStore.userResponse.role.name;
  const pageSize = 40;
  const filterOptions: string[] =
    role === UserAccessConstants.SUPER_ADMIN
      ? ticketManagementConstants.DETAILS_MODAL.filterOptions
      : ticketManagementConstants.DETAILS_MODAL.filterOptions.slice(0, -1);

  //State Variables
  const [activeTicketsLoading, setActiveTicketsLoading] = useState<boolean>(
    false,
  );
  const [closedTicketsLoading, setClosedTicketsLoading] = useState<boolean>(
    false,
  );
  const [newTicketModalOpen, setNewTicketModalOpen] = useState<boolean>(false);
  const [deletePopUpOpen, setDeletePopUpOpen] = useState<boolean>(false);
  const [activeTickets, setActiveTickets] = useState<any>('');
  const [closedTickets, setClosedTickets] = useState<any>('');
  const [activeTicketsTable, setActiveTicketsTable] = useState<any>('');
  const [closedTicketsTable, setClosedTicketsTable] = useState<any>('');
  const [detailsWindowOpen, setDetailsWindowOpen] = useState<boolean>(false);
  const [selectedTicketId, setSelectedTicketId] = useState<string>('');
  const [selectedActionTable, setSelectedActionTable] = useState<string>('');
  const [isActiveTicketsExpand, setIsActiveTicketsExpand] = useState<boolean>(
    true,
  );
  const [isClosedTicketsExpand, setIsClosedTicketsExpand] = useState<boolean>(
    false,
  );
  const [searchValue, setSearchValue] = useState<string>('');
  const [isFilterOpen, setIsFilterOpen] = useState<boolean>(false);
  const [assigneeOptions, setAssigneeOptions] = useState<any>([]);
  const [assigneeValues, setAssigneeValues] = useState<any>([]);
  const [types, setTypes] = useState<any>([]);
  const [
    activeTicketsPageNumber,
    setActiveTicketsPageNumber,
  ] = useState<number>(1);
  const [
    activeTicketstotalPages,
    setActiveTicketsTotalPages,
  ] = useState<number>(0);
  const [
    closedTicketsPageNumber,
    setClosedTicketsPageNumber,
  ] = useState<number>(1);
  const [
    closedTicketstotalPages,
    setClosedTicketsTotalPages,
  ] = useState<number>(0);
  const [filter, setFilters] = useState<FilterData[]>([]);

  //snackbar
  const handleOpenSnackBar = (
    message: string,
    severity: MuiColor,
    duration: number | null,
  ) => {
    setSnackbarState({
      open: true,
      message: message,
      severity: severity,
      duration: duration,
    });
  };

  const handleCloseSnackBar = (
    event?: React.SyntheticEvent,
    reason?: string,
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarState({
      open: false,
      message: '',
      severity: undefined,
      duration: null,
    });
  };

  const [snackbarState, setSnackbarState] = React.useState<{
    open: boolean;
    message: string;
    severity: MuiColor | undefined;
    duration: null | number;
  }>({
    open: false,
    message: '',
    severity: undefined,
    duration: null,
  });

  //Functions

  const handleSearchChange = (value: any) => {
    setSearchValue(value);
    if (!value) {
      getActiveTickets();
      getClosedTickets();
    } else {
      const topic = value.toLowerCase();
      getActiveTickets(topic);
      getClosedTickets(topic);
    }
  };

  const handleTicketMenu = (
    index: number,
    item: string,
     
    event: any,
    rowId: string,
  ) => {
    let ticketId = '';
    setSelectedActionTable(rowId);
    switch (rowId) {
      case 'activeTickets':
        ticketId = activeTicketsTable[index][0];
        break;
      case 'closedTickets':
        ticketId = closedTicketsTable[index][0];
        break;
      default:
        break;
    }
    switch (item) {
      case 'View / Edit Details':
        setSelectedTicketId(ticketId);
        setDetailsWindowOpen(true);
        break;
      case 'Delete':
        setSelectedTicketId(ticketId);
        setDeletePopUpOpen(true);
        break;
    }
  };

  const handleActiveTicketsPageChange = (
    event: ChangeEvent<unknown>,
    page: number,
  ) => {
    setActiveTicketsPageNumber(page);
  };

  const handleClosedTicketsPageChange = (
    event: ChangeEvent<unknown>,
    page: number,
  ) => {
    setClosedTicketsPageNumber(page);
  };

  const handleApplyFilter = (data: any) => {
    const updatedFilter = {
      ...(data?.Platform && { platform: data?.Platform }),
      ...(data?.Type && { type: data?.Type }),
      ...(data?.Status && { status: data?.Status }),
      ...(data?.Priority && { priority: data?.Priority }),
      ...(data?.Assignee && { assigneeId: data?.Assignee }),
    };
    setIsFilterOpen(false);
    getActiveTickets(undefined, updatedFilter);
    getClosedTickets(undefined, updatedFilter);
  };

  const generateFilterOptions = (
    items: any[],
    values?: string[],
  ): FilterOption[] =>
    items?.map((item, index) => ({
      label: item,
      value: values ? values[index] : item,
      selected: false,
    }));

  const formatData = (): FilterData[] =>
    filterOptions?.map((option: string) => {
      const filtersMapping: Record<string, () => FilterOption[]> = {
        Platform: () =>
          generateFilterOptions(
            ticketManagementConstants.DETAILS_MODAL.platformOptions,
          ),
        Type: () => generateFilterOptions(types),
        Status: () =>
          generateFilterOptions(
            ticketManagementConstants.DETAILS_MODAL.statusOptions,
            ticketManagementConstants.DETAILS_MODAL.statusValues,
          ),
        Priority: () =>
          generateFilterOptions(
            ticketManagementConstants.DETAILS_MODAL.priorityOptions,
            ticketManagementConstants.DETAILS_MODAL.priorityValues,
          ),
        Assignee: () => generateFilterOptions(assigneeOptions, assigneeValues),
      };

      return {
        name: option,
        showAll: false,
        filters: filtersMapping[option]?.() || [],
      };
    });

  //Apis
  const getAssigneesList = async () => {
    await axios
      .get(
        properties.userManagementBaseUrl +
        properties.users +
        properties.getByRole +
        '/SUPER_ADMIN',
      )
      .then((res: any) => {
        if (res.status === 200) {
          const options = res?.data?.map((item: any) => {
            return getAvatarComponent(
              item.email,
              item.firstName,
              item.lastName,
            );
          });
          const values = res?.data?.map((item: any) => item.id);
          setAssigneeOptions([
            <div style={{ display: 'flex', gap: '5px', alignItems: 'center' }}>
              <AvatarEmpty />
              None
            </div>,
            ...options,
          ]);
          setAssigneeValues([null, ...values]);
        }
      })
      .catch((err: any) => {
        handleOpenSnackBar(
          'Something went wrong. Please try later',
          'error',
          3000,
        );
        throw err;
      });
  };

  const hanldeCreateNewTicket = async (data: any) => {
    handleOpenSnackBar('Ticket creation in progress', 'info', 2000);
    const reqBody = {
      ...(data.issue && { topic: data.issue }),
      ...(data.platform && { platform: data.platform }),
      ...(data.description && { description: data.description }),
      ...(data.priority && { priority: data.priority }),
      ...(data.type && { type: data.type }),
      ...(data.dueDate && {
        dueDate: moment(data.dueDate).format('YYYY-MM-DD'),
      }),
      ...(data.assignee && { assigneeId: { id: data.assignee } }),
      ...(data.assignee && {
        assignedBy: { id: userId },
      }),
    };

    await axios
      .post(
        properties.userManagementBaseUrl +
        properties.tickets +
        properties.createTicket +
        `/${userId}`,
        reqBody,
      )
      .then((res: any) => {
        if (res.status === 200) {
          if (data.attachments.length > 0) {
            data.attachments?.map((item: any) => {
              addAttachmentDetails(item, res.data.ticketId);
            });
          }
          handleOpenSnackBar('Ticket has been created', 'success', 2000);
          getActiveTickets();
        }
      })
      .catch((err: any) => {
        handleOpenSnackBar('Ticket creation failed.', 'error', 3000);
        throw err;
      });
  };

  const addAttachmentDetails = async (fileData: any, ticketId: string) => {
    const reqBody = {
      fileUrl: fileData.fileUrl,
      fileName: fileData.fileName,
      fileMimeType: fileData.fileMimeType,
      fileSize: formatFileSize(fileData.fileSize),
      ticketId: { ticketId: ticketId },
      uploadedBy: { id: loginPageStore.userId },
    };
    await axios.post(
      properties.userManagementBaseUrl +
      properties.attachments +
      properties.addDetails,
      reqBody,
    );
  };

  const deleteTicket = async (ticketId: string) => {
    handleOpenSnackBar('Ticket deletion in progress', 'info', 2000);
    let tickets: any = [];
    selectedActionTable === 'activeTickets'
      ? (tickets = activeTickets)
      : selectedActionTable === 'closedTickets'
        ? (tickets = closedTickets)
        : [];
    const existingDetails = tickets.find(
      (item: any) => item.ticketId === selectedTicketId,
    );
    await axios
      .put(
        properties.userManagementBaseUrl +
        properties.tickets +
        properties.updateTicket +
        `/${ticketId}` +
        `/${userId}`,
        { ...existingDetails, deleted: true },
      )
      .then((res: any) => {
        if (res.status === 200) {
          handleOpenSnackBar('Ticket has been deleted', 'success', 2000);
          getActiveTickets();
          getClosedTickets();
          setDetailsWindowOpen(false);
        }
      })
      .catch((err: any) => {
        handleOpenSnackBar('Ticket deletion failed.', 'error', 3000);
        throw err;
      });
  };

  const updateTicket = async (ticketId: string, data: any) => {
    handleOpenSnackBar('Ticket updation in progress', 'info', 2000);
    let tickets: any = [];
    selectedActionTable === 'activeTickets'
      ? (tickets = activeTickets)
      : selectedActionTable === 'closedTickets'
        ? (tickets = closedTickets)
        : [];
    const existingDetails = tickets.find(
      (item: any) => item.ticketId === selectedTicketId,
    );
    const reqBody = {
      ...(data.issue && { topic: data.issue }),
      ...(data.platform && { platform: data.platform }),
      ...(data.description && { description: data.description }),
      ...(data.priority && { priority: data.priority }),
      ...(data.type && { type: data.type }),
      ...(data.status && { status: data.status }),
      ...(data.dueDate && {
        dueDate: moment(data.dueDate).format('YYYY-MM-DD'),
      }),
      ...(data.assignee && { assigneeId: { id: data.assignee } }),
      ...(data.assignee && {
        assignedBy: {
          id:
            existingDetails?.assigneeId?.id === data?.assignee
              ? existingDetails.assignedBy.id
              : userId,
        },
      }),
      updatededBy: { id: userId },
    };

    await axios
      .put(
        properties.userManagementBaseUrl +
        properties.tickets +
        properties.updateTicket +
        `/${ticketId}` +
        `/${userId}`,
        reqBody,
      )
      .then((res: any) => {
        if (res.status === 200) {
          handleOpenSnackBar('Ticket has been updated', 'success', 2000);
          getActiveTickets();
          getClosedTickets();
        }
      })
      .catch((err: any) => {
        handleOpenSnackBar('Ticket updation failed.', 'error', 3000);
        throw err;
      });
  };

  const getActiveTickets = async (topic?: string, filters?: any) => {
    const reqBody = {
      deleted: [false],
      createdBy: role === UserAccessConstants.SUPER_ADMIN ? null : userId,
      status: ['to_do', 'in_progress', 'in_review'],
      topic: topic,
      ...filters,
    };
    await axios
      .post(
        properties.userManagementBaseUrl +
        properties.tickets +
        properties.getAllTickets,
        reqBody,
        {
          params: {
            page: activeTicketsPageNumber - 1,
            size: pageSize,
            sort: 'updatedAt',
            direction: 'desc',
          },
        },
      )
      .then((res: any) => {
        if (res.status === 200) {
          setActiveTickets(res.data.content);
          setActiveTicketsTable(
            formatTicketData(
              res.data.content,
              role,
              setSelectedTicketId,
              setDetailsWindowOpen,
            ),
          );
          setActiveTicketsTotalPages(res.data.totalPages);
        }
      })
      .catch((err: any) => {
        handleOpenSnackBar('Fetching Tickets Api Failed', 'error', 3000);
        throw err;
      });
  };

  const getClosedTickets = async (topic?: string, filters?: any) => {
    const reqBody = {
      deleted: [false],
      createdBy: role === UserAccessConstants.SUPER_ADMIN ? null : userId,
      status: ['completed'],
      topic: topic,
      ...filters,
    };
    await axios
      .post(
        properties.userManagementBaseUrl +
        properties.tickets +
        properties.getAllTickets,
        reqBody,
        {
          params: {
            page: closedTicketsPageNumber - 1,
            size: pageSize,
            sort: 'updatedAt',
            direction: 'desc',
          },
        },
      )
      .then((res: any) => {
        if (res.status === 200) {
          setClosedTickets(res.data.content);
          setClosedTicketsTable(
            formatTicketData(
              res.data.content,
              role,
              setSelectedTicketId,
              setDetailsWindowOpen,
            ),
          );
          setClosedTicketsTotalPages(res.data.totalPages);
        }
      })
      .catch((err: any) => {
        handleOpenSnackBar('Fetching Tickets Api Failed', 'error', 3000);
        throw err;
      });
  };

  const getUniquePlatformAndTypes = async () => {
    await axios
      .get(
        properties.userManagementBaseUrl +
        properties.tickets +
        properties.uniqueValues,
      )
      .then((res: any) => {
        if (res.status === 200) {
          setTypes(
            Array.from(
              new Set([
                ...ticketManagementConstants.DETAILS_MODAL.TypeOptions,
                ...res.data.types,
              ]),
            ),
          );
        }
      })
      .catch((err: any) => {
        throw err;
      });
  };

  //Use Effects
  useEffect(() => {
    setFilters(formatData());
  }, [types, assigneeOptions, assigneeValues]);

  useEffect(() => {
    const fetchTickets = async () => {
      setActiveTicketsLoading(true);
      await Promise.all([getActiveTickets()]);
      setActiveTicketsLoading(false);
    };
    fetchTickets();
  }, [activeTicketsPageNumber]);

  useEffect(() => {
    const fetchTickets = async () => {
      setClosedTicketsLoading(true);
      await Promise.all([getClosedTickets()]);
      setClosedTicketsLoading(false);
    };
    fetchTickets();
  }, [closedTicketsPageNumber]);

  useEffect(() => {
    role === UserAccessConstants.SUPER_ADMIN ? getAssigneesList() : '';
    getUniquePlatformAndTypes();
  }, []);

  return (
    <>
      <div>
        <Grid container className={classes.root}>
          {activeTicketsLoading && closedTicketsLoading ? (
            <CircularLoader />
          ) : activeTickets.length > 0 || closedTickets.length > 0 ? (
            <>
              <Grid
                style={{
                  marginBottom: '36px',
                  width: '1437px',
                  position: 'relative',
                }}
              >
                <PageTitleAndSubTitle
                  title={ticketManagementConstants.MAIN_PAGE.title}
                  subTitle={ticketManagementConstants.MAIN_PAGE.subTitle}
                  subTitleStyles={{ width: '90%' }}
                />
              </Grid>
              <Grid>
                <CardComponent
                  title={''}
                  body={
                    <Grid container>
                      <Grid
                        container
                        className={classes.accordion}
                        style={{
                          width: detailsWindowOpen ? '60%' : '100%',
                        }}
                        sx={{
                          flexDirection: 'column',
                        }}
                      >
                        <BasicAccordion
                          title={
                            ticketManagementConstants.MAIN_PAGE.activeTickets
                          }
                          content={
                            activeTicketsLoading ? (
                              <CircularLoader />
                            ) : (
                              <BasicTable
                                columns={
                                  role === UserAccessConstants.SUPER_ADMIN
                                    ? tableColumns
                                    : tableColumns.map((column) =>
                                      column.name === 'Assignee'
                                        ? { ...column, name: 'Priority' }
                                        : column,
                                    )
                                }
                                rowsData={activeTicketsTable}
                                displayType="row"
                                isMenuAvailable={true}
                                menuOptions={
                                  ticketManagementConstants.MAIN_PAGE
                                    .menuOptions
                                }
                                handleCellMenuItem={handleTicketMenu}
                                rowId={'activeTickets'}
                                hideColumnIndex={0}
                                showPagination={true}
                                pageCount={activeTicketstotalPages}
                                pageNumber={activeTicketsPageNumber}
                                handlePagination={handleActiveTicketsPageChange}
                                columnId=""
                              />
                            )
                          }
                          width={'100%'}
                          expandDefault={isActiveTicketsExpand}
                          handleClick={() => {
                            setIsActiveTicketsExpand(!isActiveTicketsExpand);
                          }}
                          accordionDetailsStyles={{
                            overflowX: 'scroll',
                            ...scrollBarStyles,
                            display: 'flex',
                            justifyContent: 'center',
                          }}
                        />
                        <BasicAccordion
                          title={
                            ticketManagementConstants.MAIN_PAGE.closedTickets
                          }
                          content={
                            closedTicketsLoading ? (
                              <CircularLoader />
                            ) : (
                              <BasicTable
                                columns={
                                  role === UserAccessConstants.SUPER_ADMIN
                                    ? tableColumns
                                    : tableColumns.map((column) =>
                                      column.name === 'Assignee'
                                        ? { ...column, name: 'Priority' }
                                        : column,
                                    )
                                }
                                rowsData={closedTicketsTable}
                                displayType="row"
                                isMenuAvailable={true}
                                menuOptions={
                                  ticketManagementConstants.MAIN_PAGE
                                    .menuOptions
                                }
                                handleCellMenuItem={handleTicketMenu}
                                rowId={'closedTickets'}
                                hideColumnIndex={0}
                                showPagination={true}
                                pageCount={closedTicketstotalPages}
                                pageNumber={closedTicketsPageNumber}
                                handlePagination={handleClosedTicketsPageChange}
                                columnId=""
                              />
                            )
                          }
                          width={'100%'}
                          expandDefault={isClosedTicketsExpand}
                          handleClick={() => {
                            setIsClosedTicketsExpand(!isClosedTicketsExpand);
                          }}
                          accordionDetailsStyles={{
                            overflowX: 'scroll',
                            ...scrollBarStyles,
                            display: 'flex',
                            justifyContent: 'center',
                          }}
                        />
                      </Grid>
                      {detailsWindowOpen && (
                        <TicketDetailsWindow
                          ticketId={selectedTicketId}
                          setDeletePopUpOpen={setDeletePopUpOpen}
                          setDetailsWindowOpen={setDetailsWindowOpen}
                          ticketDetails={
                            activeTickets.find(
                              (item: any) => item.ticketId === selectedTicketId,
                            ) ??
                            closedTickets.find(
                              (item: any) => item.ticketId === selectedTicketId,
                            )
                          }
                          role={role}
                          handleSave={updateTicket}
                          handleOpenSnackBar={handleOpenSnackBar}
                          assigneeOptions={assigneeOptions}
                          assigneeValues={assigneeValues}
                        />
                      )}
                    </Grid>
                  }
                  width="98%"
                  mainGridStyles={{ overflow: 'visible' }}
                  searchBar="Search Tasks"
                  handleSearchChange={handleSearchChange}
                  searchValue={searchValue}
                  topRightItem={
                    <>
                      <div className={classes.topRightButtons}>
                        <Button
                          color="primary"
                          height="36px"
                          width="120px"
                          label="Filters"
                          startIcon={<Filter />}
                          onClick={() => setIsFilterOpen((prev) => !prev)}
                        />
                        <Button
                          color="primary"
                          variant="contained"
                          height="36px"
                          width="180px"
                          label="Create New Ticket"
                          onClick={() => {
                            setNewTicketModalOpen(true);
                          }}
                        />
                      </div>
                      {isFilterOpen && (
                        <TicketFilterModal
                          filter={filter}
                          setFilters={setFilters}
                          handleApplyFilter={handleApplyFilter}
                        />
                      )}
                    </>
                  }
                />

                <Grid style={{ margin: '2rem 0' }}>
                  <Typography fontType="medium" fontSize="14px" align="center">
                    For any more information or assistance contact us at{' '}
                    <a
                      href="mailto:help@homahealth.us"
                      rel="noopener noreferrer"
                    >
                      help@homahealth.us
                    </a>
                  </Typography>
                </Grid>
              </Grid>
            </>
          ) : (
            <NoComplianceAssurances
              title={ticketManagementConstants.MAIN_PAGE.title}
              subTitle={ticketManagementConstants.MAIN_PAGE.welcome}
              image={<SupportCenter />}
              buttonLabel={ticketManagementConstants.DETAILS_MODAL.title}
              handleOnclick={() => {
                setNewTicketModalOpen(true);
              }}
              startIcon={''}
              rootStyles={{ border: '0px', background: '', padding: '20px' }}
            />
          )}
          <div id="scroll-top-element"></div>
        </Grid>
        {pageScrollDown('scroll-top-element')}
      </div>
      <Snackbar
        {...snackbarState}
        handleClose={handleCloseSnackBar}
        vertical="bottom"
        horizontal="right"
      />
      {newTicketModalOpen && (
        <NewTicketModal
          open={newTicketModalOpen}
          setOpen={setNewTicketModalOpen}
          handleSubmit={hanldeCreateNewTicket}
          assigneeOptions={assigneeOptions}
          assigneeValues={assigneeValues}
          handleOpenSnackBar={handleOpenSnackBar}
        />
      )}
      {deletePopUpOpen && (
        <BasicModal
          open={deletePopUpOpen}
          title={ticketManagementConstants.MAIN_PAGE.delete}
          body={
            <Typography
              fontSize="12px"
              lineHeight="17px"
              fontType="medium"
              textColor={patientAccessTheme.palette.text.highemphasis}
              margin="0px 0px 15px 0px"
            >
              {ticketManagementConstants.MAIN_PAGE.deleteDesc}
            </Typography>
          }
          cancelButtonLabel={ticketManagementConstants.DETAILS_MODAL.cancel}
          confirmButtonLabel={ticketManagementConstants.DETAILS_MODAL.confirm}
          handleCancel={() => setDeletePopUpOpen(false)}
          handleConfirm={() => {
            deleteTicket(selectedTicketId);
            setDeletePopUpOpen(false);
          }}
          handleClose={() => setDeletePopUpOpen(false)}
        />
      )}
    </>
  );
});

export default TicketManagementPage;
